// extracted by mini-css-extract-plugin
module.exports = {"content":"ContestPage_content__2Gngj","img":"ContestPage_img__3QzJA","human_img":"ContestPage_human_img__22zZe","description":"ContestPage_description__gpLFr"};